import defaultImage from '@/presentation/assets/defaultImage.png'
import { StyledImage } from './styles'

export function Image({ src, ...props }) {
  return <StyledImage imageSrc={src || defaultImage} {...props} />
}
